// Previous types exported gesture handlers as classes which creates an interface and variable, both named the same as class.
// Without those types, we'd introduce breaking change, forcing users to prefix every handler type specification with typeof
// e.g. React.createRef<TapGestureHandler> -> React.createRef<typeof TapGestureHandler>.
// See https://www.typescriptlang.org/docs/handbook/classes.html#constructor-functions for reference.
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import * as React from "react";
import { Platform, findNodeHandle as findNodeHandleRN } from "react-native";
import { handlerIDToTag } from "./handlersRegistry";
import { toArray } from "../utils";
import RNGestureHandlerModule from "../RNGestureHandlerModule";
import { ghQueueMicrotask } from "../ghQueueMicrotask";
var commonProps = [
    "id",
    "enabled",
    "shouldCancelWhenOutside",
    "hitSlop",
    "cancelsTouchesInView",
    "userSelect",
    "activeCursor"
];
var componentInteractionProps = [
    "waitFor",
    "simultaneousHandlers"
];
export var baseGestureHandlerProps = _to_consumable_array(commonProps).concat(_to_consumable_array(componentInteractionProps), [
    "onBegan",
    "onFailed",
    "onCancelled",
    "onActivated",
    "onEnded",
    "onGestureEvent",
    "onHandlerStateChange"
]);
export var baseGestureHandlerWithMonitorProps = _to_consumable_array(commonProps).concat([
    "needsPointerData",
    "manualActivation"
]);
function isConfigParam(param, name) {
    // param !== Object(param) returns false if `param` is a function
    // or an object and returns true if `param` is null
    return param !== undefined && (param !== Object(param) || !("__isNative" in param)) && name !== "onHandlerStateChange" && name !== "onGestureEvent";
}
export function filterConfig(props, validProps) {
    var defaults = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var filteredConfig = _object_spread({}, defaults);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = validProps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var value = props[key];
            if (isConfigParam(value, key)) {
                if (key === "simultaneousHandlers" || key === "waitFor") {
                    value = transformIntoHandlerTags(props[key]);
                } else if (key === "hitSlop" && typeof value !== "object") {
                    value = {
                        top: value,
                        left: value,
                        bottom: value,
                        right: value
                    };
                }
                filteredConfig[key] = value;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return filteredConfig;
}
function transformIntoHandlerTags(handlerIDs) {
    handlerIDs = toArray(handlerIDs);
    if (Platform.OS === "web") {
        return handlerIDs.map(function(param) {
            var current = param.current;
            return current;
        }).filter(function(handle) {
            return handle;
        });
    }
    // converts handler string IDs into their numeric tags
    return handlerIDs.map(function(handlerID) {
        var _handlerID_current;
        return handlerIDToTag[handlerID] || ((_handlerID_current = handlerID.current) === null || _handlerID_current === void 0 ? void 0 : _handlerID_current.handlerTag) || -1;
    }).filter(function(handlerTag) {
        return handlerTag > 0;
    });
}
export function findNodeHandle(node) {
    if (Platform.OS === "web") {
        return node;
    }
    return findNodeHandleRN(node);
}
var flushOperationsScheduled = false;
export function scheduleFlushOperations() {
    if (!flushOperationsScheduled) {
        flushOperationsScheduled = true;
        ghQueueMicrotask(function() {
            RNGestureHandlerModule.flushOperations();
            flushOperationsScheduled = false;
        });
    }
}
